import React from "react";
import Header from "../Header";
import Main from "../Main";
import { WEBSITE_DATA, CURRENT_DOMAIN } from "../../constants/dashboard";
import { useNavigate } from "react-router-dom";
import "./style.css";

const Dashboard = () => {
  const navigate = useNavigate();

  const goto = (data) => {
    if (data.name === "CP") {
      navigate("/cp");
    } else if (data.name === "TAS") {
      navigate("/tas");
    } else {
      navigate("/sos");
    }
  };

  return (
    <>
      <Header />
      <div>
        <Main />
        <div className="content">
          <h2>{WEBSITE_DATA.title}</h2>
          <p>{WEBSITE_DATA.desc}</p>
          <div className="cards">
            {WEBSITE_DATA.innderComponents
              .filter((a) => a.domains.includes(CURRENT_DOMAIN))
              .map((b, idx) => (
                <img
                  key={idx}
                  className="card"
                  src={b?.img}
                  alt=""
                  onClick={() => goto(b)}
                />
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
